
import { X, Calendar, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SubscriptionForm } from "./SubscriptionForm";
import { trackExitIntent } from "@/utils/metaPixel";

export const DesktopExitPopup = ({ 
  isVisible,
  onDismiss 
}: { 
  isVisible: boolean;
  onDismiss: () => void;
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full relative animate-in fade-in zoom-in duration-300">
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-2 top-2"
          onClick={() => {
            trackExitIntent('dismissed');
            onDismiss();
          }}
        >
          <X className="h-4 w-4" />
        </Button>
        
        <div className="p-6">
          <div className="mb-4">
            <Calendar className="h-12 w-12 text-primary mb-4" />
            <h2 className="text-2xl font-bold text-primary mb-2">
              Never Miss Critical Home Maintenance Again!
            </h2>
            <p className="text-muted-foreground mb-4">
              Get Your Free Seasonal Maintenance Calendar:
            </p>
            <ul className="space-y-2 mb-6">
              <li className="flex items-start">
                <span className="text-primary mr-2">•</span>
                Monthly maintenance checklists
              </li>
              <li className="flex items-start">
                <span className="text-primary mr-2">•</span>
                Pro tips from local experts
              </li>
            </ul>
          </div>

          <SubscriptionForm />
        </div>
      </div>
    </div>
  );
};
